import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DataSourcePanel = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const dataSources = [
    {
      id: 'coinmarketcap',
      name: 'CoinMarketCap',
      url: 'https://coinmarketcap.com',
      description: 'Real-time stablecoin market capitalization data',
      icon: 'Database',
      reliability: 'High'
    },
    {
      id: 'federal-reserve',
      name: 'Federal Reserve Economic Data (FRED)',
      url: 'https://fred.stlouisfed.org',
      description: 'Official US M2 money supply statistics',
      icon: 'Building2',
      reliability: 'Official'
    },
    {
      id: 'coingecko',
      name: 'CoinGecko',
      url: 'https://coingecko.com',
      description: 'Secondary verification for stablecoin data',
      icon: 'CheckCircle2',
      reliability: 'High'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-4 md:p-6 transition-colors duration-300 hover:bg-muted"
      >
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
            <Icon name="Shield" size={20} color="var(--color-primary)" />
          </div>
          <div className="text-left">
            <h3 className="text-base md:text-lg font-semibold text-foreground">
              Data Sources & Methodology
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">
              Transparent attribution and calculation methods
            </p>
          </div>
        </div>
        
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={20} 
          color="var(--color-muted-foreground)" 
        />
      </button>
      {isExpanded && (
        <div className="px-4 md:px-6 pb-4 md:pb-6 space-y-4">
          <div className="pt-4 border-t border-border">
            <h4 className="text-sm font-semibold text-foreground mb-3">
              Primary Data Sources
            </h4>
            <div className="space-y-3">
              {dataSources?.map((source) => (
                <div 
                  key={source?.id}
                  className="flex items-start gap-3 p-3 rounded-lg bg-muted/50"
                >
                  <div className="flex items-center justify-center w-8 h-8 rounded bg-background flex-shrink-0">
                    <Icon name={source?.icon} size={16} color="var(--color-primary)" />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <a 
                        href={source?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-medium text-foreground hover:text-primary transition-colors duration-300"
                      >
                        {source?.name}
                      </a>
                      <span className="px-2 py-0.5 text-xs font-medium bg-success/10 text-success rounded-full">
                        {source?.reliability}
                      </span>
                    </div>
                    <p className="text-xs text-muted-foreground line-clamp-2">
                      {source?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <h4 className="text-sm font-semibold text-foreground mb-2">
              Calculation Methodology
            </h4>
            <div className="space-y-2 text-xs md:text-sm text-muted-foreground">
              <p>
                <strong className="text-foreground">Stablecoin Market Cap:</strong> Sum of top 10 stablecoins by market capitalization (USDT, USDC, DAI, BUSD, TUSD, USDP, GUSD, USDD, FRAX, LUSD)
              </p>
              <p>
                <strong className="text-foreground">M2 Money Supply:</strong> Latest official Federal Reserve M2 data (seasonally adjusted)
              </p>
              <p>
                <strong className="text-foreground">Ratio Calculation:</strong> (Total Stablecoin Market Cap / US M2 Money Supply) × 100
              </p>
            </div>
          </div>

          <div className="pt-4 border-t border-border">
            <div className="flex items-start gap-2 p-3 rounded-lg bg-primary/5">
              <Icon name="Info" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs text-muted-foreground">
                Data is updated every 15 minutes during market hours. Historical data is preserved for trend analysis. All calculations are performed with precision to 4 decimal places.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DataSourcePanel;